const updates = [
  {
    time: '10分钟前',
    tag: '最新',
    title: '某短视频平台头部主播疑似签约纠纷细节流出',
    summary: '据知情人士透露，该主播与原经纪公司之间的合约矛盾由来已久，最新进展引发行业关注。',
  },
  {
    time: '28分钟前',
    tag: '热点',
    title: '热门综艺节目录制现场突发状况引发网友热议',
    summary: '一段现场观众拍摄的视频在网上疯传，节目组尚未对此事作出正式回应。',
  },
  {
    time: '1小时前',
    tag: '爆料',
    title: '知名艺人工作室凌晨发布声明澄清近期传闻',
    summary: '声明中否认了多项网络传言，并表示将保留追究法律责任的权利。',
  },
  {
    time: '2小时前',
    tag: '更新',
    title: '某城市热门商圈发生群体冲突事件全程视频流出',
    summary: '多角度视频展示了事件全貌，目前相关部门已介入调查处理。',
  },
  {
    time: '3小时前',
    tag: '独家',
    title: '行业内部人士透露某平台即将进行大规模人事调整',
    summary: '消息源称此次调整涉及多个核心业务部门，预计将在月底前官宣。',
  },
  {
    time: '5小时前',
    tag: '跟进',
    title: '前日爆料事件持续发酵：多方当事人回应汇总',
    summary: '在舆论压力下，多位相关当事人在社交平台相继发表声明，事件走向更加扑朔迷离。',
  },
  {
    time: '7小时前',
    tag: '快讯',
    title: '某品牌代言人突陷负面风波，品牌方紧急公关',
    summary: '多家品牌方的社交媒体账号已删除与该代言人相关内容，公关团队正在紧急处理中。',
  },
  {
    time: '9小时前',
    tag: '回顾',
    title: '本月911爆料吃瓜黑料合集：十大最热事件回顾',
    summary: '从月初到月底，让我们一起回顾本月最具话题性的十大吃瓜黑料事件，温故知新。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              实时<span className="text-primary-500">快讯</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              7×24小时滚动更新，第一时间掌握911吃瓜黑料最新动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-3 bottom-3 w-0.5 bg-secondary-200 hidden sm:block"></div>

            <div className="space-y-0">
              {updates.map((item, idx) => (
                <div
                  key={idx}
                  className="flex gap-4 sm:gap-6 pb-6 last:pb-0 relative"
                >
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                    <div className={`w-3 h-3 rounded-full border-2 border-background-100 z-10 ${
                      idx === 0 ? 'bg-primary-500' : 'bg-secondary-300'
                    }`}></div>
                  </div>

                  <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 md:p-5 hover:bg-background-100 transition-colors duration-200 cursor-pointer">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className={`px-2 py-0.5 text-xs font-bold rounded whitespace-nowrap ${
                        idx === 0
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}